import { PRODUCT_STATUS } from '@/enums/status.enum'
import { FILTER_PRE_REGISTER } from '@/enums/campaign.enum'

export const paginationCampaign = {
  page: 1,
  perPage: 15,
  type: 'ทั้งหมด',
  slug: undefined,
  name: undefined,
}

export const paginationMainProduct = {
  page: 1,
  perPage: 15,
  campaignId: undefined,
}

export const paginationProduct = {
  type: PRODUCT_STATUS.all,
  nameOrSku: '',
}

export const paginationPreregister = {
  page: 1,
  campaignId: undefined,
  type: FILTER_PRE_REGISTER.PRE_REGISTER,
}

const state = () => ({
  campaign: paginationCampaign,
  mainProduct: paginationMainProduct,
  product: paginationProduct,
  preregister: paginationPreregister,
})

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
